export default __webpack_public_path__ + "static/media/good_inactive.b79fb92a.svg";